import produce from 'immer';
import {
  FETCH_INCREMENT_REQUESTED,
  FETCH_DECREMENT_SUCCEED,
  FETCH_DECREMENT_REQUESTED,
  FETCH_INCREMENT_SUCCEED,
  FETCH_LOGIN_REQUESTED, FETCH_LOGIN_FAIL,
  FETCH_LOGIN_SUCCEED,
  LOGOUT
} from './actionTypes';

const initialState = {
  count: 0,
  isIncrementing: false,
  isDecrementing: false,
  isLoginInProgress: false,
  access_token: localStorage.getItem('SARAFAN_ADMIN_ACCESS_TOKEN') || null,
  user: JSON.parse(localStorage.getItem('SARAFAN_ADMIN_USER')|| null) ,
};

const AuthErrors = {
  loginFailed: 'Не удалось авторизоваться. Проверьте email или пароль.'
}
const authReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_INCREMENT_REQUESTED:
      draft.isIncrementing= true
      return draft

    case FETCH_INCREMENT_SUCCEED:
      draft.count = draft.count +1;
      draft.isIncrementing = !draft.isIncrementing
      draft.user = null
      draft.access_token = null
      return  draft

    case FETCH_DECREMENT_REQUESTED:
      draft.isDecrementing= true
      return draft

    case FETCH_DECREMENT_SUCCEED:
      draft.count = draft.count - 1;
      draft.isDecrementing = !draft.isDecrementing
      return  draft

    case FETCH_LOGIN_REQUESTED:
      draft.isLoginInProgress = true
      return  draft

    case FETCH_LOGIN_SUCCEED:
      localStorage.setItem('SARAFAN_ADMIN_ACCESS_TOKEN', action.payload.access_token)
      localStorage.setItem('SARAFAN_ADMIN_USER', JSON.stringify(action.payload.user))
      draft.isLoginInProgress = false
      draft.user = action.payload.user
      draft.access_token = action.payload.access_token
      draft.error = null
      return  draft

    case FETCH_LOGIN_FAIL:
      draft.isLoginInProgress = false
      draft.error = AuthErrors.loginFailed
      draft.user = null
      draft.access_token = null
      return  draft

    case LOGOUT:
      draft.isLoginInProgress = false
      draft.user = null
      draft.access_token = null
      localStorage.clear()
      return  draft

    default:
      return draft;
  }
});
export default authReducer;



// WEBPACK FOOTER //
// ./src/store/auth/reducer.js